import {
  FETCH_ITINERARIES, FETCH_ITINERARIES_FAIL, POST_ITINERARIES, POST_ITINERARIES_FAIL, POST_ITINERARIES_LOADING
} from './types';
import { SLACK_WEBHOOKS } from '../config';
import axios from 'axios';
import { SlackWebhook } from './utils';
import { history } from '../components/app';
import { FetchCities } from '../actions/cities';
import { FetchCyoaProducts } from '../actions/products';
import { AddAccomodationPayload } from '../helpers/bookingHelper';
// import { FetchBooking } from '../actions/booking';
import { store } from '../index';

/**
 * Get booking information by cyoa token
 * Fetch booking via Busabout API
 *
 * @param {string} cyoaToken - cyoa secret hash
 */
export function FetchIntineraries(cyoaToken){

  const bookingURL = `${process.env.REACT_APP_ITINERARIES_API}/${cyoaToken}?api_token=${process.env.REACT_APP_API_TOKEN}`;
  const config = { withCredentials: true};

  return async dispatch => {
    try{
      const response = await axios.get(bookingURL, config);
      dispatch({type:FETCH_ITINERARIES, payload:response.data});

      if(Object.keys(store.getState().cyoaProducts).length === 0) dispatch(FetchCyoaProducts(response.data.data.iso_currency, response.data.data.trips[0].tour_id ));
      if(Object.keys(store.getState().cities).length === 0) dispatch(FetchCities(response.data.data.iso_currency,response.data.data.trips[0].tour_id ));
      return Promise.resolve(response.data.data);
    }
    catch(err){
      console.error(err);
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Itineraries API (GET) - ' + bookingURL + " " + err}));
      dispatch({type:FETCH_ITINERARIES_FAIL});
      if(process.env.REACT_APP_ENV === "production"){
        if((err && err.response.status === 404)) history.push('/404');
        if((err && err.response.status === 500)) history.push('/500');
      }
    }
  }
}


/**
 * Get booking information by booking id and email
 * Fetch booking via Busabout API
 *
 * @param {string} cyoaToken - cyoa secret hash
 */
export function FetchIntinerariesByID(bookingId, email){

  const bookingURL = `${process.env.REACT_APP_ITINERARIES_API}/auth/${bookingId}/${email}?api_token=${process.env.REACT_APP_API_TOKEN}`;
  const config = { withCredentials: true};

  return async dispatch => {
    try{
      const response = await axios.get(bookingURL, config)

      dispatch({type:FETCH_ITINERARIES, payload:response.data});
      // dispatch(FetchBooking(response.data.data.tms_group_booking_id));
      if(Object.keys(store.getState().cyoaProducts).length === 0) dispatch(FetchCyoaProducts(response.data.data.iso_currency));
      if(Object.keys(store.getState().cities).length === 0)  dispatch(FetchCities(response.data.data.iso_currency));
    }
    catch(err){
      console.error(err);
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Itineraries API (GET) - ' + bookingURL + " " + err}));
      dispatch({type:FETCH_ITINERARIES_FAIL});
      if(process.env.REACT_APP_ENV === "production"){
        if((err && err.response.status === 404)) history.push('/404');
        if((err && err.response.status === 500)) history.push('/500');
      }
    }
  }
}



/**
 * Post itineraries accomodation by cyoa token and tms booking id
 *
 * @param {string} cyoaToken - cyoa secret hash
 * @param {number} tmsBookingId - tms booking id
 * @param {object} payload - accomodation payload
 * @param {boolean} postFetchItineraries - accomodation payload
 */
export function PostIntinerariesAccomodation(itineraries, postFetchItineraries = false, isToggle = false, isChecked=true, globalRoomType = 'default'){


  const URL = `${process.env.REACT_APP_ITINERARIES_API}/${itineraries.cyoa_token}/accommodation?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${itineraries.tms_group_booking_id}`;
  const config = { withCredentials: true};
  const payload = AddAccomodationPayload(itineraries, isToggle, isChecked, globalRoomType);

  return async dispatch => {

    if(itineraries.total_paid === "0.00"){

      dispatch({type:POST_ITINERARIES_LOADING, payload:true});

      try{
        const response = await axios.post(URL, payload, config);
        //console.log('RESPONSE', response)
        dispatch({type:POST_ITINERARIES, payload:false});
        if(postFetchItineraries)dispatch({type:FETCH_ITINERARIES, payload:response.data});
        dispatch({type:POST_ITINERARIES_LOADING, payload:false});
        
        return await Promise.resolve();
      }
      catch(err){
          console.error(err);
          dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Itineraries API (POST) - '  + URL + " " + err}));
          // history.push('/500');
          dispatch({type:POST_ITINERARIES_FAIL, payload:false});
      }

    }

  }
}



// WEBPACK FOOTER //
// ./src/actions/itineraries.js